const isProduction = process.env.NODE_ENV === "production";

const SharedSubscriptionConstants = {
  statuses: {
    UNACTIVATED: "unactivated",
    FREE: "free",
    ACTIVE: "active",
    PAST_DUE: "past_due",
    UNPAID: "unpaid",
    CANCELED: "canceled",
  },

  currentPricingVersion: "january_2024",

  legacyPricingVersions: {
    LIFETIME_FREE: "lifetime_free", // super early supporters
    BUYMEACOFFEE_2023: "buymeacoffee_2023",
  },

  /**
   * @note many priceIDs can corrspend to the same price, e.g. monthly, annual, lifetime
   * @note these are the archivedPriceIDs, necessary for code to work with previously used priceIDs
   * @note priceID is the current priceID
  */
  pricing: {
    january_2024: {
      monthly: {
        priceID: isProduction ? "price_1OVCaZIZd2YKFOBkgSO394jw" : "price_1NlfKhIZd2YKFOBkkAamMMLH",
        archivedPriceIDs: ["price_1Nk90oIZd2YKFOBkrewSFW0q"],
        prices: {
          usd: 4.99,
        },
      },
      annual: {
        priceID: isProduction ? "price_1OVCe9IZd2YKFOBkB15RIyHB" : "price_1NlfL1IZd2YKFOBkiQISJUel",
        archivedPriceIDs: ["price_1Nk91pIZd2YKFOBkhKWMAb8T"],
        prices: {
          usd: 49,
        },
      },
      lifetime: {
        priceID: isProduction ? "price_1OVCZwIZd2YKFOBkXjsFBdmg" : "price_1NMFcSIZd2YKFOBkL96jeABu",
        archivedPriceIDs: ["price_1NMFeAIZd2YKFOBkuNaOFlOE"],
        prices: {
          usd: 89.99,
        },
      },
    },

    buymeacoffee_2023: {
      monthly: {
        priceID: isProduction ? "price_1OVCleIZd2YKFOBkPcZD8nOS" : "price_1OUCgEIZd2YKFOBkl5pS3or4",
        archivedPriceIDs: ["price_1OUCeDIZd2YKFOBkEuUL2r9b"],
        prices: {
          usd: 3,
        },
      },
      annual: {
        priceID: isProduction ? "price_1OVCmAIZd2YKFOBki6oLh3iF" : "price_1OUCgdIZd2YKFOBk16ycL3dh",
        archivedPriceIDs: ["price_1OUCevIZd2YKFOBk0CC6ELAn"],
        prices: {
          usd: 30,
        },
      },
      lifetime: {
        priceID: isProduction ? "price_1OVCZwIZd2YKFOBkXjsFBdmg" : "price_1NMFcSIZd2YKFOBkL96jeABu",
        archivedPriceIDs: ["price_1NMFeAIZd2YKFOBkuNaOFlOE"],
        prices: {
          usd: 89.99,
        },
      },
    },
  },

  /** Here you can modify what is displayed on the settings page*/
  plans: {
    monthly: {
      plan: "Premium Club (Monthly)",
      description: "Unlimited access to all Cofocus features.",
    },
    annual: {
      plan: "Premium Club (Annual)",
      description: "Unlimited access to all Cofocus features.",
    },
    lifetime: {
      plan: "Premium Club (Lifetime)",
      description: "Unlimited access to all Cofocus features.",
    },
    cancel_at_period_end: {
      plan: "Premium Club (Canceled)",
      description: "Unlimited access to all Cofocus features until end of billing period.",
    },
    past_due: {
      plan: "Premium Club (Past Due)",
      description: "Access restricted to 3 sessions/week until subscription payment succeeds.",
    },
    free: {
      plan: "Free",
      priceTag: "$0/month",
      description: "3 sessions/week for free.",
    },
    unknown_plan: {
      plan: "Unknown Plan",
      priceTag: "?/???",
      description: "Something went wrong. Please contact support@cofocus.one. Thank you!",
    },
  },
};

module.exports = SharedSubscriptionConstants;
